module.exports = __webpack_public_path__ + "static/media/assets-management.8e68d031.jpg";